export const GOOGLE_REVIEWS_URL = "https://share.google/BnYOuRH1kPhNa4BeV";

export interface Testimonial {
  name: string;
  quote: string;
  rating: number;
}

export const realTestimonials: Testimonial[] = [
  {
    name: "Carter",
    quote: "During the process of starting my business, he answered every question and gave great advice. Communication was spot on.",
    rating: 5
  },
  {
    name: "Charles Rodolakis",
    quote: "Brandon has consistently made my business website better over the past couple years. Kind, honest, and professional.",
    rating: 5
  },
  {
    name: "Kylee Fordyce",
    quote: "Super friendly and knowledgeable. Great website design help and marketing pointers, with strong follow-through.",
    rating: 5
  }
];
